import { useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useHistory } from 'react-router-dom';
import { createOpportunity } from 'services/api/requests/demand/opportunity/opportunity';
import { mapErrorToToastProps } from 'utils/forms/mapErrorToToastProps';

export const useCreateOpportunity = (
	onErrorHierarchyNotFound?: VoidFunction
) => {
	const queryClient = useQueryClient();
	const history = useHistory();
	const toast = useToast();
	return useMutation((body: any) => createOpportunity(body), {
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['oportunidade-list'] });
			history.goBack();
			toast({
				title: 'Criada com sucesso!',
				description: 'Oportunidade criada com sucesso.',
				position: 'bottom-left',
				status: 'success',
				duration: 8000,
				isClosable: true,
			});
		},
		onError: (error: any) => {
			if (error?.status === 428 || error?.response?.status === 428) {
				if (onErrorHierarchyNotFound) {
					onErrorHierarchyNotFound();
				}
			} else {
				const toastErrors: Array<any> = mapErrorToToastProps(
					error,
					'Erro ao criar oportunidade!'
				);
				for (const element of toastErrors) {
					toast(element);
				}
			}
		},
	});
};
